<template>
  <v-layout row wrap fill-height align-center justify-center class="secondary">
    <v-flex xs12 sm6 md4 lg4 xl2>
      <v-card>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-text-field v-model="email" :rules="emailRules" label="Email Address" required></v-text-field>

            <v-text-field
              v-model="password"
              :append-icon="show ? 'visibility' : 'visibility_off'"
              :rules="[passrules.required, passrules.min]"
              :type="show ? 'text' : 'password'"
              label="Password"
              hint="At least 8 characters"
              @click:append="show = !show"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <span class="error--text" v-if="errorMsg" v-html="errorMsg"></span>
          <v-spacer/>
          <v-btn color="warning" @click="doLogin">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import { login } from "../api/user";

export default {
  name: "Login",
  data: () => ({
    valid: true,
    errorMsg: "",
    password: "",
    show: false,
    nameRules: [
      v => !!v || "Username is required",
      v => (v && v.length <= 10) || "Name must be less than 10 characters"
    ],
    passrules: {
      required: value => !!value || "Required.",
      min: v => v.length >= 8 || "Min 8 characters",
      emailMatch: () => "The email and password you entered don't match"
    },
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+/.test(v) || "E-mail must be valid"
    ],
    select: null,
    items: ["Item 1", "Item 2", "Item 3", "Item 4"],
    checkbox: false
  }),

  methods: {
    doLogin() {
      this.errorMsg = "";
      login(this.email, this.password).then(response => {
        if (response.error) {
          this.errorMsg = response.error;
        }
      });
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>